module.exports = __webpack_public_path__ + "static/media/link.2b2f7c9a.svg";